
const { API, graphqlOperation } = require("aws-amplify");
const {
  createMCZV1,
  deleteMCZV1,
  updateMCZV1,
} = require("@/graphql/mutations");
const {
  listMCZV1s,
  getMCZV1,
  listDataFromLsiStr1,
  listDataFromLsiStr2,
} = require("@/graphql/queries");
const short = require('short-uuid');
const UserInfo = require('../appUtils/UserInfo');
const dayjs = require('dayjs')
//require('dayjs/locale/ja');

/**
 * ミーティング用のデータ取得モデルクラス
 */
class baseModel {

  static getNowDate() {
    return dayjs().format('YYYY-MM-DD HH:mm:ss.SSS')
  }
  /**
   * リストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async getList(skCondition, _tenantId = null, maxrecord = 0, sortdirection = "ASC") {
    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }
    
    if (!tenantId) {
      return;
    }

    // 1回で取得する件数
    let limit = 10;
    // 最大件数が指定されている場合は超えないようにする。
    if (maxrecord > 0 && maxrecord < limit) {
      limit = maxrecord
    }
    let remain = maxrecord > 0 ? maxrecord : null
    let nextToken = ''
    let dataList = []
    
    while (nextToken !== null) {

      let result;
      console.log(`getList: ${limit} remain ${remain}`)
      if (nextToken.length > 0) {

        result = await API.graphql(
          graphqlOperation(listMCZV1s, {
            pk: tenantId,
            sk: skCondition, //{ beginsWith: "meeting" },
            sortDirection: sortdirection,
            limit: remain > limit ? limit : remain,
            nextToken
          })
        );
      } else {
        // 初回取得時はnextTokenを指定するとパラメータエラーになる
        result = await API.graphql(
          graphqlOperation(listMCZV1s, {
            pk: tenantId,
            sk: skCondition, //{ beginsWith: "meeting" },
            sortDirection: sortdirection,
            limit: limit,
          })
        );
      }
      //alert(JSON.stringify(result))
      if (result) {
        if (result.data) {
          // console.log(`getList : ${result.data.listMCZV1s.items.length}`)

          dataList = dataList.concat(result.data.listMCZV1s.items)

          // console.log(`nextToken : ${result.data.listMCZV1s.nextToken}`)
          // 続きを取得
          nextToken = result.data.listMCZV1s.nextToken
          
          // remainが指定されているか
          if (remain) {
            // 残りを計算
            remain = remain - limit
            if (remain <= 0) {
              // 残りがなければ終了
              nextToken = null
            }
          }
        }
      }
    }
    // 削除は除く
    return dataList.filter(function(item) {
      return !item._deleted
    }.bind(this));
  }
  static async getLsistr1List(lsiStr1Condition, _tenantId = null) {
    
    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }

    if (!tenantId) {
      return;
    }

    // 1回で取得する件数
    const limit = 10;
    let nextToken = ''
    let dataList = []

    while (nextToken !== null) {
      let result;

      if (nextToken.length > 0) {
        result = await API.graphql(
          graphqlOperation(listDataFromLsiStr1, {
            pk: tenantId,
            lsiStr1: lsiStr1Condition, //{ beginsWith: "meeting" },
            limit: limit,
            nextToken
          })
        );
      } else {
        // 初回取得時はnextTokenを指定するとパラメータエラーになる
        result = await API.graphql(
          graphqlOperation(listDataFromLsiStr1, {
            pk: tenantId,
            lsiStr1: lsiStr1Condition, //{ beginsWith: "meeting" },
            limit: limit,
          })
        );
      }
      //alert(JSON.stringify(result))
      if (result) {
        if (result.data) {

          dataList = dataList.concat(result.data.listDataFromLsiStr1.items)

          nextToken = result.data.listDataFromLsiStr1.nextToken
        }
      }
    }

    return dataList.filter(function(item) {
      return !item._deleted
    }.bind(this));
  }
  static async getLsistr2List(lsiStr2Condition, _tenantId = null, maxrecord = 0, sortdirection = "ASC") {
    
    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }

    if (!tenantId) {
      return;
    }

    // 1回で取得する件数
    let limit = 10;
    // 最大件数が指定されている場合は超えないようにする。
    if (maxrecord > 0 && maxrecord < limit) {
      limit = maxrecord
    }
    let remain = maxrecord > 0 ? maxrecord : null
    let nextToken = ''
    let dataList = []

    while (nextToken !== null) {
      let result;

      if (nextToken.length > 0) {
        result = await API.graphql(
          graphqlOperation(listDataFromLsiStr2, {
            pk: tenantId,
            lsiStr2: lsiStr2Condition, 
            sortDirection: sortdirection,
            limit: remain > limit ? limit : remain,
            nextToken
          })
        );
      } else {
        // 初回取得時はnextTokenを指定するとパラメータエラーになる
        result = await API.graphql(
          graphqlOperation(listDataFromLsiStr2, {
            pk: tenantId,
            lsiStr2: lsiStr2Condition, 
            sortDirection: sortdirection,
            limit: limit,
          })
        );
      }
      //alert(JSON.stringify(result))
      if (result) {
        if (result.data) {

          dataList = dataList.concat(result.data.listDataFromLsiStr2.items)

          nextToken = result.data.listDataFromLsiStr2.nextToken

          // remainが指定されているか
          if (remain) {
            // 残りを計算
            remain = remain - limit
            if (remain <= 0) {
              // 残りがなければ終了
              nextToken = null
            }
          }
        }
      }
    }

    return dataList.filter(function(item) {
      return !item._deleted
    }.bind(this));
  }
  /**
   * レコードを削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async deleteData(data) {
    // console.log(`deleteData ${JSON.stringify(data, null, "\t")}`)
    if (!data) {
      console.log(`data is empty`)
      return;
    }

    await API.graphql(
      graphqlOperation(deleteMCZV1, {
        input: { pk: data.pk, sk: data.sk, _version: data._version },
      })
    );
    //alert(`ok`)
  }
  /**
   * レコードを更新する
   * @param {*} data
   */
  static async updateData(data, condition = null) {
    //TODO:更新されているかをチェックすること
    delete data.createdAt;
    delete data.updatedAt;
    delete data._deleted;
    delete data._lastChangedAt;
    
    delete data.groups;

    data.modifiedAd = "web"
    // console.log(`updateData: ${JSON.stringify(data, null, "\t")}`)
    // alert(`updateData`)
    
    // const paramsString = JSON.stringify(data, null, "\t");
    console.log(`sk: ${data.sk}`);
    let result = null
    if (condition) {
      result = await API.graphql(
        graphqlOperation(updateMCZV1, { input: data, condition: condition})
      );
    } else {
      result = await API.graphql(
        graphqlOperation(updateMCZV1, { input: data})
      );
    }
    
    // console.log(`updateData compare ${JSON.stringify(data)} ${JSON.stringify(result.data.updateMCZV1)}`)
    // 更新後のレコードをレスポンスする。更新データの_versionがDB上の_versionと一致しない場合は更新は行われない。
    // resultには最新のレコードがセットされている。
    return result
  }

  /**
   * レコードを追加する
   * @param {*} data
   */
  static async addData(data) {
    delete data.createdAt;
    delete data.updatedAt;
    delete data._deleted;
    delete data._lastChangedAt;

    data.modifiedAd = "web"
    const paramsString = JSON.stringify(data, null, "\t");
    console.log(`addData: ${paramsString}`);

    
    return await API.graphql(
      graphqlOperation(createMCZV1, { input: data })
    );
  }

  /**
   * ミーティング管理レコードを取得する
   * @param {*} data
   */
  static async getSingleData(data, _tenantId = null) {
    // const loginInfo = await UserInfo.getUserInfo()
    // if (!loginInfo.group) {
    //   console.log(`グループなし`)
    //   return null
    // }
    // const tenantId = loginInfo.group

    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }

    if (!tenantId) {
      console.log(`テナント無し`)
      return;
    }

    let result = await API.graphql(
      graphqlOperation(getMCZV1, { pk: tenantId, sk: data.sk })
    );

    return result.data.getMCZV1;
  }

  /**
   * 新規登録用のスキーマ
   */
  static async getNewData(_tenantId = null) {
    // const loginInfo = await UserInfo.getUserInfo()
    // if (!loginInfo.group) {
    //   return null
    // }
    // const tenantId = loginInfo.group

    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }
    
    return {
      pk: `${tenantId}`,
      sk: "",
      lsiStr1: "-",
      lsiStr2: "-",
      lsiStr3: "-",
      lsiStr4: "-",
      lsiInt1: 0,
      groups: [tenantId],
      ttl: 0

    };
  }
  /**
   * 指定された時間待ちます。
   *
   * @param waitTimeMsec 待ち時間(msec)
   */
  static sleep(waitTimeMsec) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, waitTimeMsec)
    })
  }
}

module.exports = baseModel;
